import React, { useState, useEffect } from 'react';

const Paymentgateway = () => {
  const [payid, setPayid] = useState('');
  const [oldId, setOldId] = useState('');
  const [message, setMessage] = useState('');

  const fetchPayid = async () => {
    const token = `Bearer ${localStorage.getItem('token')}`; // Replace with actual token

    try {
      const response = await fetch("https://api.experts4u.in/api/v1/paymentgateway/GetPaymentgateway", {
        method: "GET",
        headers: {
          "Authorization": token,
        },
      });
      
      const result = await response.json();
      if (response.ok && result.length > 0) {
        setOldId(result[0].payid); // Displaying the first payid
      } else {
        setMessage("No payment gateway data found");
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("Server error");
    }
  };

  useEffect(() => {
    fetchPayid();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = `Bearer ${localStorage.getItem('token')}`; // Replace with actual token

    try {
      const response = await fetch("https://api.experts4u.in/api/v1/paymentgateway/Paymentgateway", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": token,
        },
        body: JSON.stringify({ payid, oldId }),
      });

      const result = await response.json();
      if (response.ok) {
        setMessage(result.message);
        fetchPayid();
        setPayid('');
      } else {
        setMessage("Failed to update payment gateway");
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("Server error");
    }
  };

  const clearAll = async () => {
    const token = `Bearer ${localStorage.getItem('token')}`; // Replace with actual token

    try {
      const response = await fetch("https://api.experts4u.in/api/v1/paymentgateway/AllPaymentgateway", {
        method: "DELETE",
        headers: {
          "Authorization": token,
        },
      });

      if (response.ok) {
        setMessage("All payment gateways cleared successfully");
        fetchPayid(); // Refresh the data
        setPayid('');
        setOldId('');
      } else {
        setMessage("Failed to clear payment gateways");
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("Server error");
    }
  };

  return (
    <div className='app has-fullwidth'>
      <div className="app-main">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <h4 className="card-title">Payment Gateway</h4>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={clearAll}
                >
                  Clear All
                </button>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  {oldId.length > 0 && (
                    <div className="form-group">
                      <label>Old ID</label>
                      <input
                        type="text"
                        className="form-control"
                        value={oldId}
                        onChange={(e) => setOldId(e.target.value)}
                        required
                      />
                    </div>
                  )}
                  <div className="form-group">
                    <label>New Payment Gateway ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={payid}
                      onChange={(e) => setPayid(e.target.value)}
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">Submit</button>
                </form>
                {message && <div className="alert alert-info mt-3">{message}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Paymentgateway;
